import { getReceiptGrandTotal } from '../components/receipt/receiptDetailsModal';

/** Receipt fields used to compute the booking-details summary total. */
export type BookingReceiptDisplayInput = {
  totalPrice?: number | null;
  totalPriceWithFees?: number | null;
  totalPriceWithPostTripCharges?: number | null;
  postTripIncidentChargesTotal?: number | null;
};

/**
 * Amount shown on booking details before opening the receipt modal
 * (Financials "Total Earnings" / "Total Price"). Mirrors Flutter receipt card total.
 */
export function getBookingReceiptDisplayTotal(
  receipt?: BookingReceiptDisplayInput | null,
  invoices?: unknown[] | null,
): number {
  return getReceiptGrandTotal(receipt, invoices as any[]) ?? receipt?.totalPrice ?? 0;
}
